import React from "react";
import { InputRangeRow } from "./index";
import { helpers } from "../../utils";
// Used by Heli KV2008B and Heli KV2019B machines

export default function LowerDeckRow({ minProp, maxProp }) {
   const { formatNumberWithThousands } = helpers;
   return (
      <InputRangeRow
         titleProp={"Lower Deck (f=50Hz)"}
         descriptionProp={"r/min"}
         sizeProp={6}
         colSizeProp={6}
         typeProp={"text"}
         minProp={minProp || 5000}
         maxProp={maxProp || 15000}
         propertyNameProp={"deckLower"}
         errorDialogueProp={minProp ? `${formatNumberWithThousands(minProp)}-${formatNumberWithThousands(maxProp)}` : "5,000-15,000 only"}
         floatProp={false}
      />
   );
}
